import React, {useState, useEffect, useCallback} from 'react';

import ProductList from 'views/product/ProductList';
import AdAPI from 'service/api/AdAPI';

import Input from 'muicss/lib/react/input';
import Button from 'muicss/lib/react/button';
import Dispatcher from 'service/Dispatcher';
import Countdown from 'react-countdown-now';
import HeaderContainer from 'containers/HeaderContainer';
import Footer from 'views/Footer';
import {Img} from 'views/AppElements';
import {Helmet} from "react-helmet";

import CacheService from 'service/CacheService';

import 'css/ad.css';

const CODERS_MERCH_END_DATE = "CODERS_MERCH_END_DATE";

function isValidEmail(email) 
{
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email))
        return true;

    return false;
}

const CountDownRenderer = (props) => {
    const isPlural = (num) => num > 1;

    const hoursLabel = <div className='flexColumn eachTimerBox'><span className='timer'>{props.formatted.hours}</span> <span className='timerLabel'>hour{isPlural(props.hours)? 's': ''}</span></div>
    const minutesLabel = <div className='flexColumn eachTimerBox'><span className='timer'>{props.formatted.minutes}</span> <span className='timerLabel'>minute{isPlural(props.minutes)? 's': ''}</span></div>
    const secondsLabel = <div className='flexColumn eachTimerBox'><span className='timer'>{props.formatted.seconds}</span> <span className='timerLabel'>second{isPlural(props.seconds)? 's': ''}</span></div>

    return <div className='flexColumn' id="codersCouponCountDown">
            <div className='flexRow timerBox'>
                {hoursLabel}
                {minutesLabel}
                {secondsLabel}
            </div>
        </div>;
};

const EmailForm = () => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (event) => {
        setEmail(event.target.value);
    };

    const handleFormSubmit = useCallback((event) => {
        event.preventDefault();
        
        Dispatcher.dispatchClearAlert();
        if(!isValidEmail(email)) {
            Dispatcher.dispatchAnAlert({message: "Invalid Email Address", type: "ERROR"});
            return;
        }

        setIsSubmitting(true);

        AdAPI.subscribeToCodersMerchCoupon(email.toLowerCase().trim(), (success) => {
            console.log("Success", success);
            setIsSubmitting(false);

            if(success)
                setEmail('');
        })
    }, [email]);

    let endDate = CacheService.get(CODERS_MERCH_END_DATE);

    if(!endDate) {
        //add 24 hour to current time;
        const expiryTime = new Date().getTime() + (24 * 60 * 60 * 1000)
        endDate = new Date(expiryTime);

        CacheService.save(CODERS_MERCH_END_DATE, endDate.getTime(), true);
    } else {
        endDate = new Date(parseInt(endDate, 10));
    }

    const hasExpired = endDate.getTime() < new Date().getTime();
    return (
        <div id="codersEmailForm">
            <h1>MERCH FOR CODERS</h1>

            <div id="couponCodeTitle">
                GET AN EXCLUSIVE COUPON CODE FOR
                <h5 id="discountPct">15% OFF</h5>
            </div>

            <form id="couponEmailForm" onSubmit={handleFormSubmit}>
                <Input type="email" placeholder="ENTER YOUR E-MAIL" onChange={handleInputChange} value={email} id="couponSubscriberEmailTxt" name="couponSubscriberEmailTxt" />
                <Button type="submit" id="couponSubscriberSubmitBtn" disabled={isSubmitting || email === '' || hasExpired} onClick={handleFormSubmit}>

                    {isSubmitting === false &&
                        <span>SUBMIT</span>
                    }
                    {isSubmitting === true && 
                        <span><i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i> SUBMIT</span>
                    }
                </Button>
            </form>
            
            
            <h2>
                {hasExpired? "OFFER EXPIRED": "OFFER ENDS IN"}</h2>
            <Countdown date={endDate} renderer={CountDownRenderer} />
        </div>
    );
};

const CodersCampaign = (props) => {
    const [products, setProducts] = useState(null);

    useEffect(() => {
        AdAPI.getCodersMerch((products) => {
            setProducts(products);
        });
    }, []);
    return <div id="codersCampaign">
        <Helmet>
            <title>15% OFF Discount Coupon on Coders Merch, Sweatshirt, Frame For Limited Time | Seto Canvas</title>
            <meta name="description" content="Get 15% off discount coupon on Coders Merch, Sweatshirt, Frame for limited time." />
        </Helmet>
        <HeaderContainer />

        <div id="codersCampaignHeader" className="flexRow">
            <div className="merchBannerImg">
                <Img src="/images/banners/coders-campaign/sweatshirt-left.jpg" alt="May the Stackoverflow be with you Sweatshirt | Coders Merch Available on SetoCanvas.com" />
            </div>
            
            <EmailForm />
            <div className="merchBannerImg">
                <Img src="/images/banners/coders-campaign/sweatshirt-right.jpg" alt="There is no place like 127.0.0.1 Sweatshirt | Coders Merch Available on SetoCanvas.com" />
            </div>
        </div>
        

        <div className="mainContainer">
            <ProductList title={"MOST POPULAR"} products={products} viewProductTags={true} flattenProductImages={true}
					productViewMode="productOnly" emptyMsg="No Coding Merch Found" />
        </div>

        <Footer />
        
    </div>
};


export default CodersCampaign;




// WEBPACK FOOTER //
// ./src/pages/campaigns/CodersCampaign.js